import { com } from '@eidu/form'
import entityApiUrl from '../baseUrl'
import requireValidPaginationParameters from '../common/requireValidPaginationParameters'
import AuthenticationContext from '../../authorization/AuthenticationContext'
import { logMessage } from '../../../util/Logging'
import EntityType = com.eidu.sharedlib.entity.type.EntityType
import entityTypePaginatedResponseFromJsonString = com.eidu.sharedlib.entity.api.types.entityTypePaginatedResponseFromJsonString
import PaginatedResponse = com.eidu.sharedlib.entity.api.common.PaginatedResponse

type GetEntityTypesParameters = { pageIndex: number; pageSize: number; authContext: AuthenticationContext }

const getEntityTypes = ({
  pageIndex,
  pageSize,
  authContext,
}: GetEntityTypesParameters): Promise<PaginatedResponse<EntityType> | null> => {
  requireValidPaginationParameters(pageIndex, pageSize)

  return fetch(
    `${entityApiUrl}/organizations/${authContext.organizationId}/types?pageIndex=${pageIndex}&pageSize=${pageSize}`,
    {
      headers: {
        Authorization: `Bearer ${authContext.accessToken}`,
        Accept: 'application/json',
      },
    }
  ).then(async (response) => {
    switch (response.status) {
      case 200:
        return entityTypePaginatedResponseFromJsonString(await response.text())
      case 404:
        logMessage(`Got status ${response.status} from getEntityTypes endpoint`, 'warning')
        return null
      default:
        throw Error(`Unexpected response code ${response.status} from getEntityTypes endpoint`)
    }
  })
}

export default getEntityTypes
